export default {
  FreeText: 1,
  DatePicker: 2,
  TimePicker: 3,
  Dropdown: 4,
  HtmlEditor: 5,
  Carousel: 6,
  Address: 7,
}
